import React from 'react';
import PropTypes from 'prop-types';

import FormGroup from 'components/FormGroup/FormGroup';
import FormItem from 'components/FormItem/FormItem';
import IconButton from 'components/IconButton/IconButton';
import Input from 'components/Input/Input';
import Panel from 'components/Panel/Panel';
import PanelHeader from 'components/PanelHeader/PanelHeader';
import Select from 'components/Select/Select';

import { ffd_versions, nds, taxes } from './constants';

import Check24 from 'icons/Check24';
import Close24 from 'icons/Close24';

import { validateTerminalKeyPass } from 'utils/validate';

import styles from '../terminal.scss';

function Tinkoff(props) {
    const { terminalSettings, isLoading, onCancel, onTerminalSave } = props;

    const [settings, setSettings] = React.useState(terminalSettings);
    const [settingsErrors, setSettingsErrors] = React.useState({
        terminal_key: null,
        terminal_password: null,
    });

    React.useEffect(() => {
        setSettings(terminalSettings);
    }, [terminalSettings]);

    function handleTextFieldChange(e) {
        const field = e.target.name;
        const value = e.target.value;
        const error = validateTerminalKeyPass(value);
        setSettingsErrors((prev) => ({ ...prev, [field]: error }));

        setSettings((prev) => {
            return {
                ...prev,
                [field]: value,
            };
        });
    }

    function updateSelectParameter(parameterName, value) {
        setSettings((prev) => {
            return {
                ...prev,
                [parameterName]: value,
            };
        });
    }

    function handleTaxationChange(value) {
        updateSelectParameter('taxation_type', value);
    }

    function handleFfdChagne(value) {
        updateSelectParameter('ffd', value);
    }

    function handleVatChange(value) {
        updateSelectParameter('vat', value);
    }

    function validateSettings() {
        const [terminal_key] = [validateTerminalKeyPass(settings.terminal_key)];
        setSettingsErrors({ terminal_key });

        return !terminal_key;
    }

    function handleTerminalSave() {
        const terminalSettings = {
            terminal_key: settings.terminal_key,
            terminal_password: settings.terminal_password,
            taxation_type: settings.taxation_type,
            ffd: settings.ffd,
            vat: settings.vat,
            return_url: 'https://google.com',
        };

        if (!validateSettings()) return;

        onTerminalSave(terminalSettings);
    }

    return (
        <Panel
            separated={true}
            contentStyles={{ minWidth: 400, maxWidth: 400, padding: '0 0.5rem' }}
            header={
                <PanelHeader
                    title={'Тинькофф Банк'}
                    back={true}
                    onBackClick={onCancel}
                    backIcon={<Close24 />}
                    after={
                        <IconButton accent={true} loading={isLoading} onClick={handleTerminalSave} icon={<Check24 />} />
                    }
                />
            }
        >
            <div className={styles.settings}>
                {!settings ? null : (
                    <FormGroup>
                        <FormItem>
                            <p className={styles.note}>
                                Подробную информацию о вашем терминале можно найти в аккаунте Тинькофф Бизнес.
                            </p>
                        </FormItem>

                        <FormItem label={'Номер терминала'} error={settingsErrors.terminal_key}>
                            <Input
                                type="text"
                                name="terminal_key"
                                value={settings.terminal_key}
                                onChange={handleTextFieldChange}
                            />
                        </FormItem>

                        <FormItem
                            label={'Пароль'}
                            caption={'Не будет выводиться здесь, даже если установлен'}
                            error={settingsErrors.terminal_password}
                        >
                            <Input
                                type="password"
                                name="terminal_password"
                                value={settings.terminal_password}
                                onChange={handleTextFieldChange}
                            />
                        </FormItem>

                        <FormItem label={'Система налогообложения'}>
                            <Select
                                options={taxes}
                                onChange={handleTaxationChange}
                                defaultValue={settings.taxation_type}
                            ></Select>
                        </FormItem>

                        <FormItem label={'Версия ФФД'}>
                            <Select
                                options={ffd_versions}
                                onChange={handleFfdChagne}
                                defaultValue={settings.ffd}
                            ></Select>
                        </FormItem>

                        <FormItem label={'НДС'}>
                            <Select options={nds} onChange={handleVatChange} defaultValue={settings.vat}></Select>
                        </FormItem>
                    </FormGroup>
                )}
            </div>
        </Panel>
    );
}

Tinkoff.propTypes = {
    id: PropTypes.number,
    type: PropTypes.string,
    isLoading: PropTypes.bool,
    onCancel: PropTypes.func,
    onTerminalSave: PropTypes.func,
    terminalSettings: PropTypes.shape({
        terminal_key: PropTypes.string,
        terminal_password: PropTypes.string,
        taxation_type: PropTypes.oneOf(['osn', 'usn_income', 'usn_income_outcome', 'patent', 'envd', 'esn']),
        ffd: PropTypes.oneOf(['1.05', '1.2']),
        vat: PropTypes.oneOf(['none', 'vat0', 'vat10', 'vat18', 'vat110', 'vat118', 'vat120']),
    }),
};

export default Tinkoff;
